import {createPersistedStatePlugin} from 'pinia-plugin-persistedstate-2'
import {dateReviver} from '~/utils/helpers'

const persistedStores: string[] = [
    'persistent',
    'hotels',
    'transfers',
    'activities',
    'flights',
    'packages',
    'tours',
    'extraServices',
    'carsRent',
    'insurance',
    'cruises',
    'simpleTour',
]

export default defineNuxtPlugin(async () => {
    // TODO [P2] Need test version check and navigateTo in nuxt 3
    const {$localForage, $pinia} = useNuxtApp()
    const $conf = useRuntimeConfig()
    const cache: any = await $localForage.getItem('_persistent')
    if (cache && cache.storageVersion !== $conf.public.storageVersion) {
        await $localForage.clear()
        // await navigateTo('/')
        window.location.href = '/'
    }
    $pinia.use(
        createPersistedStatePlugin({
            storage: {
                getItem: async key => {
                    if (!persistedStores.includes(key)) return
                    return $localForage.getItem(`_${key}`)
                },
                setItem: async (key, value) => {
                    if (!persistedStores.includes(key)) return
                    return $localForage.setItem(`_${key}`, JSON.parse(JSON.stringify(value), dateReviver))
                },
                removeItem: async key => {
                    if (!persistedStores.includes(key)) return
                    return $localForage.removeItem(`_${key}`)
                },
            },
            serialize: value => value,
            deserialize: value => value,
        })
    )
    if (!cache) {
        $pinia.state.value.persistent.storageVersion = $conf.public.storageVersion
    }
})
